'use client';

import { isApiMockEnabled, setApiMockEnabled } from '@/lib/api-mock-config';
import { isNonProductionEnv } from '@/lib/enrollment-config';
import { useState, useSyncExternalStore } from 'react';

// Subscribe to nothing - we only need the snapshot
const subscribe = () => () => {};

/**
 * Dev-only switch to toggle API mock mode for testing.
 * Only renders in non-production environments.
 */
export function DevApiMockSwitch() {
  // Use useSyncExternalStore for hydration-safe client-only rendering
  const mounted = useSyncExternalStore(
    subscribe,
    () => true, // Client: mounted
    () => false // Server: not mounted
  );

  const [enabled, setEnabled] = useState(() => {
    if (typeof window === 'undefined') return false;
    return isApiMockEnabled();
  });

  // Don't render in production or before hydration
  if (!mounted || !isNonProductionEnv()) {
    return null;
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setApiMockEnabled(checked);
    setEnabled(checked);
    // Reload to apply the change
    window.location.reload();
  };

  return (
    <div className="fixed top-7 right-32 z-50 rounded-md border bg-white/90 p-2 text-xs shadow-sm backdrop-blur">
      <label className="text-muted-foreground flex cursor-pointer items-center gap-2">
        <input
          type="checkbox"
          checked={enabled}
          onChange={handleChange}
          className="h-3 w-3 cursor-pointer"
        />
        <span>Mock API</span>
      </label>
    </div>
  );
}
